module.exports = __webpack_public_path__ + "static/fonts/DINProLight.5734d307.eot";